import { ScaledBaseScene } from './scaled-base-scene';

export abstract class GameMainScene extends ScaledBaseScene {
  abstract showStartButton(showButton: boolean): void;
  abstract startRound(moves: string[], logicVersion: number): void;
  abstract setInstantFinish(): void;
  abstract autoStartGame(): void;
  abstract resetGameScene(): void;
}
